import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { Users, Plus, Trash2 } from "lucide-react"
import { Button } from "../components/ui/button.tsx"
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog.tsx"
import { Input } from "../components/ui/input.tsx"
import { Label } from "../components/ui/label.tsx"
import { RadioGroup, RadioGroupItem } from "../components/ui/radio-group.tsx"
import { ProfileLayout } from "../components/ProfileLayout"
import { useEffect } from "react"

export default function FamilyMembersPage() {
  const navigate = useNavigate()
  const [isDialogOpen, setIsDialogOpen] = useState(false)
  const [members, setMembers] = useState([])

  useEffect(() => {
  const fetchPatient = async () => {
    try {
      const response = await 
        fetch(`/apis/web/patientbymobile?mobile=${mobile}`)
      
      const data = await response.json()

      console.log("API Response:", data)

      // Adjust this based on your API structure
      if (data?.data) {
        const formatted = data.data.map((item, index) => ({
          id: index + 1,
          name: item.name,
          age: item.age,
          relation: item.relation || "self",
          gender: item.gender
        }))

        setMembers(formatted)
      }
    } catch (error) {
      console.error("Error fetching patient data:", error)
    }
  }

  fetchPatient()
}, [])

const user = JSON.parse(localStorage.getItem("user"))
const mobile = user?.mobile
console.log("Mobile:", mobile)

  const [formData, setFormData] = useState({
    name: "",
    age: "",
    relation: "",
    gender: ""
  })

  const handleLogout = () => {
    localStorage.removeItem("user")
    navigate("/")
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    setMembers([...members, { ...formData, id: Date.now() }])
    setFormData({ name: "", age: "", relation: "", gender: "" })
    setIsDialogOpen(false)
  }

  const handleDelete = (id) => {
    setMembers(members.filter(member => member.id !== id))
  }

  return (
    <ProfileLayout onLogout={handleLogout}>
      <div className="bg-gray-50 min-h-screen">
        <div className="bg-white shadow-sm border-b border-gray-200 p-6 mb-6">
          <div className="flex items-center gap-3">
            <Users className="w-6 h-6 text-red-600" />
            <h1 className="text-2xl font-bold text-gray-900">Member Details</h1>
          </div>
        </div>

        <div className="container mx-auto px-4 max-w-5xl">
          <div className="flex justify-end mb-6">
            <Button className="bg-red-700 hover:bg-red-800 gap-2 w-full sm:w-auto" onClick={() => setIsDialogOpen(true)}>
              <Plus className="w-4 h-4" />
              Add New Member
            </Button>
          </div>

        {members.length === 0 ? (
          <div className="bg-white rounded-lg shadow-sm p-12">
            <div className="flex flex-col items-center justify-center text-center">
              <div className="w-20 h-20 rounded-full bg-red-50 flex items-center justify-center mb-4">
                <Users className="w-10 h-10 text-red-600" />
              </div>
              <h2 className="text-xl font-semibold mb-2">No Members Found</h2>
              <p className="text-gray-600 mb-6">You haven't added any family members yet.</p>
              <Button className="bg-red-700 hover:bg-red-800" onClick={() => setIsDialogOpen(true)}>
                Add New Member
              </Button>
            </div>
          </div>
        ) : (
          <div className="space-y-4">
            {members.map((member) => {
              const initial = member.name.charAt(0).toUpperCase()
              return (
                <div key={member.id} className="bg-white rounded-lg shadow-sm p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                  <div className="flex items-center gap-4 w-full sm:w-auto">
                    <div className="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-gray-200 flex items-center justify-center text-xl sm:text-2xl font-semibold text-gray-700 flex-shrink-0">
                      {initial}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-base sm:text-lg font-semibold text-gray-900">{member.name}</h3>
                      <p className="text-sm text-gray-600">{member.relation} | {member.gender} {member.age} Years</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3 w-full sm:w-auto justify-end">
                    <button className="text-gray-600 hover:text-gray-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                      </svg>
                    </button>
                    <button
                      onClick={() => handleDelete(member.id)}
                      className="text-red-600 hover:text-red-700"
                    >
                      <Trash2 className="w-5 h-5" />
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        )}
        </div>
      </div>

      <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
        <DialogContent className="sm:max-w-lg">
          <DialogHeader>
            <DialogTitle>Add Family Member</DialogTitle>
          </DialogHeader>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="space-y-2">
              <Label>Name <span className="text-red-600">*</span></Label>
              <Input 
                required 
                placeholder="Enter full name"
                value={formData.name} 
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z\s]/g, '')
                  setFormData({...formData, name: value})
                }} 
              />
            </div>
            <div className="space-y-2">
              <Label>Age <span className="text-red-600">*</span></Label>
              <Input 
                required 
                type="text"
                placeholder="Enter age"
                maxLength={2}
                value={formData.age} 
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '')
                  setFormData({...formData, age: value})
                }} 
              />
            </div>
            <div className="space-y-2">
              <Label>Relation <span className="text-red-600">*</span></Label>
              <Input 
                required 
                placeholder="Enter Relation"
                value={formData.relation} 
                onChange={(e) => {
                  const value = e.target.value.replace(/[^a-zA-Z\s]/g, '')
                  setFormData({...formData, relation: value})
                }} 
              />
            </div>
            <div className="space-y-2">
              <Label>Gender <span className="text-red-600">*</span></Label>
              <RadioGroup required value={formData.gender} onValueChange={(value) => setFormData({...formData, gender: value})}>
                <div className="flex items-center space-x-6">
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="Male" id="male" />
                    <Label htmlFor="male" className="cursor-pointer">Male</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="Female" id="female" />
                    <Label htmlFor="female" className="cursor-pointer">Female</Label>
                  </div>
                  <div className="flex items-center space-x-2">
                    <RadioGroupItem value="Other" id="other" />
                    <Label htmlFor="other" className="cursor-pointer">Other</Label>
                  </div>
                </div>
              </RadioGroup>
            </div>
            <div className="flex justify-end gap-2 pt-4">
              <Button type="button" variant="outline" onClick={() => setIsDialogOpen(false)}>
                Cancel
              </Button>
              <Button type="submit" className="bg-red-700 hover:bg-red-800">
                Add Member
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </ProfileLayout>
  )
}
